"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HousePriceIndexResponse$ = exports.HousePriceIndexResponse$outboundSchema = exports.HousePriceIndexResponse$inboundSchema = void 0;
exports.housePriceIndexResponseToJSON = housePriceIndexResponseToJSON;
exports.housePriceIndexResponseFromJSON = housePriceIndexResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const housepriceindexwrapper_js_1 = require("./housepriceindexwrapper.js");
/** @internal */
exports.HousePriceIndexResponse$inboundSchema = z.object({
    data: z.array(housepriceindexwrapper_js_1.HousePriceIndexWrapper$inboundSchema),
});
/** @internal */
exports.HousePriceIndexResponse$outboundSchema = z.object({
    data: z.array(housepriceindexwrapper_js_1.HousePriceIndexWrapper$outboundSchema),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var HousePriceIndexResponse$;
(function (HousePriceIndexResponse$) {
    /** @deprecated use `HousePriceIndexResponse$inboundSchema` instead. */
    HousePriceIndexResponse$.inboundSchema = exports.HousePriceIndexResponse$inboundSchema;
    /** @deprecated use `HousePriceIndexResponse$outboundSchema` instead. */
    HousePriceIndexResponse$.outboundSchema = exports.HousePriceIndexResponse$outboundSchema;
})(HousePriceIndexResponse$ || (exports.HousePriceIndexResponse$ = HousePriceIndexResponse$ = {}));
function housePriceIndexResponseToJSON(housePriceIndexResponse) {
    return JSON.stringify(exports.HousePriceIndexResponse$outboundSchema.parse(housePriceIndexResponse));
}
function housePriceIndexResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.HousePriceIndexResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'HousePriceIndexResponse' from JSON`);
}
//# sourceMappingURL=housepriceindexresponse.js.map